import { Category } from '~app/modules/generic/models';
import { LocalStorageUtil } from '~shared/utils/localstorage.util';

declare let APP_ENV_VARIABLES;

// I am adding it here because it's a temporary local storage key
// We just wanna make sure we test it very well before enable to people
export const cachedCategoriesLocalStorageKey = 'cached_categories';

export namespace CachedCategoriesUtil {

  export function getCachedCategories(): Category[] {
    return APP_ENV_VARIABLES.categories;
  }

  export function isCachedCategoriesExisted(): boolean {
    if (!LocalStorageUtil.isFeatureEnabled(cachedCategoriesLocalStorageKey)) {
      return false;
    }
    const categories = getCachedCategories();
    return categories && Array.isArray(categories) && categories.length !== 0;
  }

  export function getCachedPromotionCategories(): Category[] {
    return APP_ENV_VARIABLES.promotionCategories;
  }

  export function isCachedPromotionCategoriesExisted(): boolean {
    if (!LocalStorageUtil.isFeatureEnabled(cachedCategoriesLocalStorageKey)) {
      return false;
    }
    const categories = getCachedPromotionCategories();
    return categories && Array.isArray(categories) && categories.length !== 0;
  }
}
